export const QA_NAME_INHABITANT_CREATION_MODAL = 'Invite'
